import { Component } from '@angular/core';
import { ReviewManager } from '@managers/review.manager';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { takeUntil, tap } from 'rxjs';
import { BaseComponent } from '../../base.component';

@Component({
    selector: 'lex-access-denied',
    templateUrl: './access-denied.component.html',
    styleUrls: ['./access-denied.component.scss'],
    standalone: false
})
export class AccessDeniedComponent extends BaseComponent {
	public isReview: boolean = false;
	constructor(private docViewerStore: DocViewerStore, private reviewManager: ReviewManager) {
		super();
		this.docViewerStore.simpleState$.pipe(
			tap(state => this.isReview = state.mode === 'review'),
			takeUntil(this.destroy$)
		).subscribe();
	}
	public close(): void {
		window.close();
	}
	public back() {
		this.reviewManager.exitReview();
	}
}
